export default (state = {}, {}) => {
  return {
    ...state,
    allCandidates: {},
  };
};
